import { isType } from "typescript-fsa";
import update from "immutability-helper";
import log from "loglevel";
import { Map } from "immutable";

import { isFailedResponseUnauthenticatedNotLogin } from "@api/actions";
import { logout } from "@auth/actions";
import * as charts from "@charts/actions";
import * as music from "@music/actions";
import * as reports from "@reports/actions";
import * as search from "@search/actions";
import * as upload from "@upload/actions";
import { makeMergeEntities } from "@orm/models";
import {
    Image,
    File,
    FileFormat,
    FilesNormalisedEntities,
    FilesInternalState as State,
 } from "../models";

const getInitialState = () => ({
    entities: {
        images: Map<number, Image>(),
        files: Map<number, File>(),
        fileFormats: Map<string, FileFormat>(),
    },
} as State);

const mergeEntities = makeMergeEntities<State, FilesNormalisedEntities>(
    ["images", "files", "fileFormats"],
);

function files(state: State = getInitialState(), action: charts.ChartsAction): State {
    // State should never be null...
    if (state === null) {
        log.warn("files state setting to null, resetting to initialState.");
        state = {} as State;
        state = update(state, { $set: getInitialState() });
    }

    if (isType(action, music.albumsIndexSuccess)) {
        // Successful albumsIndex
        return mergeEntities(state, action.payload[1].entities);
    }
    else if (isType(action, music.albumsShowSuccess)) {
        // Successful albumsShow
        return mergeEntities(state, action.payload.entities);
    }
    else if (isType(action, music.artistsShowSuccess)) {
        // Successful artistsShow
        return mergeEntities(state, action.payload.entities);
    }
    else if (isType(action, charts.chartsIndexSuccess)) {
        // Successful chartsIndex
        return mergeEntities(state, action.payload.entities);
    }
    else if (isType(action, reports.reportsIndexSuccess)) {
        // Successful reportsIndex
        return mergeEntities(state, action.payload[1].entities);
    }
    else if (isType(action, search.searchSuccess)) {
        // Successful search
        return mergeEntities(state, action.payload.entities);
    }
    else if (isType(action, upload.bundlesShowSuccess)) {
        // Successful bundlesShow
        return mergeEntities(state, action.payload.entities);
    }
    else if (isType(action, upload.bundlesIndexSuccess)) {
        // Successful bundlesIndex
        return mergeEntities(state, action.payload[1].entities);
    }
    else if (isType(action, logout) || isFailedResponseUnauthenticatedNotLogin(action)) {
        // Clear the state on logout.
        return update(state, { $set: getInitialState() });
    }
    // Otherwise we do nothing
    return state;
}

export { files, getInitialState };
